import { useCallback } from "react";

import { SessionCard } from "./SessionCard";

import type { SharedSession } from "@/queries/prompts";

export interface ShareSkillCollectionSessionRowProps {
  workspaceId: number;
  collectionId: string;
  session: SharedSession;
  index: number;
  onUpdate: (
    sessionId: string,
    fields: Partial<
      Pick<SharedSession, "name" | "is_public" | "remix_enabled" | "label_name" | "version_number">
    >,
  ) => void;
  onDelete: (sessionId: string) => void;
}

export const ShareSkillCollectionSessionRow = ({
  workspaceId,
  collectionId,
  session,
  index,
  onUpdate,
  onDelete,
}: ShareSkillCollectionSessionRowProps) => {
  const handleUpdate = useCallback(
    (
      fields: Partial<
        Pick<
          SharedSession,
          "name" | "is_public" | "remix_enabled" | "label_name" | "version_number"
        >
      >,
    ) => {
      onUpdate(session.id, fields);
    },
    [onUpdate, session.id],
  );

  const handleDelete = useCallback(() => {
    onDelete(session.id);
  }, [onDelete, session.id]);

  return (
    <SessionCard
      index={index}
      workspaceId={workspaceId}
      collectionId={collectionId}
      session={session}
      onUpdate={handleUpdate}
      onDelete={handleDelete}
    />
  );
};
